import React, { Component } from 'react';
import BasicInfoBlock from './BasicInfoBlock/BasicInfoBlock';
import PlanSettingsBlock from './PlanSettingsBlock/PlanSettingsBlock';
import './Account.css';

class Account extends Component {
	componentWillMount(){
		this.accountInfo = this.props.refreshedAccountInfo();

		if (this.accountInfo === null) {
			window.location = '/404';
		}
	}
	render(){
		return(
			<div className="account-page container">
			<div className="account-page-content">
			<BasicInfoBlock info={this.accountInfo['basicInformation']} changeLocation={this.props.changeLocation}/>
			<PlanSettingsBlock info={this.accountInfo['planSettings']} changeLocation={this.props.changeLocation}/>
			</div>
			<button className="sign-out-btn" onClick={() => this.props.logOutUser()}>Log Out</button>
			</div>
			)
	}
}

export default Account;


// WEBPACK FOOTER //
// ./src/components/Account/Account.js